import apiHandler from "../core/apiHandler";

/**
 * 📉 API para el reporte de solo lectura de stock negativo
 * Endpoint: /api/inventory/reports/negative-stock
 */
const negativeStockReportApi = apiHandler("inventory/reports/negative-stock");

export default negativeStockReportApi;
